/*
 * This file is generated by icons/template.js
 */
const SvgDelete = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
		<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z" />
	</svg>
);
SvgDelete.displayName = 'iconDelete';
export default SvgDelete;
